import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/panels.css */
  section {
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    width: 100%;
    padding: 15px 0;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
  }
  section .row {
    flex-flow: row;
    justify-content: space-between;
    margin: 0;
    padding: 0 15px;
    display: flex;
    align-items: center;
  }
  section.ai_indexes_section_1 {
    padding: 0 0 15px 0;
  }
  section .row.ai_indexes_statement_1 {
    font-size: 0.65rem;
    line-height: 130%;
    background: hsla(305, 87%, 47%, 0.1);
    padding: 10px 15px;
    margin: 0 0 15px 0;
    display: inline;
  }
  section .row.ai_indexes_statement_1 a {
    color: #fff;
    text-decoration: none;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  section .row.ai_indexes_statement_1 a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }

  section .row.ai_indexes_statement_2 {
    font-size: 0.65rem;
    line-height: 125%;
    padding: 10px 15px 0 15px;
    display: block;
  }
  section .row.ai_indexes_statement_2 b {
    font-weight: 600;
  }
  section .row.ai_indexes_selections .grid-content {
    display: grid;
    grid-template-columns: 0.15fr 1fr 0.75fr;
    overflow: auto;
    width: 50%;
  }
  section .row.ai_indexes_selections .grid-content:first-child {
    margin: 0 10px 0 0;
  }
  section .row.ai_indexes_selections .grid-content:last-child {
    margin: 0 0 0 10px;
  }
  section .row.ai_indexes_selections .table_row {
    display: contents;
  }
  section .row.ai_indexes_selections .table_row:hover .column.stock_symbol span {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
    cursor: pointer;
  }
  section .row.ai_indexes_selections .table_row .column {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 0 10px 0;
  }
  section .row.ai_indexes_selections .table_row .column.stock_symbol span.no_link {
    border-bottom: none;
    cursor: default;
  }
  section .row.ai_indexes_selections .table_row .column.stock_symbol span {
    font-size: 0.7rem;
    font-weight: 600;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    display: flex;
    position: relative;
    top: 1px;
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change span {
    font-size: 0.7rem;
    font-weight: 600;
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change.up span {
    color: hsl(126, 100%, 38%);
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change.down span {
    color: hsl(340, 88%, 46%);
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change .price_direction {
    -webkit-mask: url(${icons.bid_direction_icon}) left center / auto 10px no-repeat;
    mask: url(${icons.bid_direction_icon}) left center / auto 10px no-repeat;
    width: 10px;
    height: 10px;
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change .price_direction.up {
    background: hsl(126, 100%, 38%);
    transform: rotate(180deg);
    margin: 0 3px 0 0;
  }
  section .row.ai_indexes_selections .table_row .column.stock_current_change .price_direction.down {
    background: hsl(340, 88%, 46%);
    transform: rotate(0deg);
    margin: 0 0 0 3px;
  }
  .ai_asset_icon {
    background: #000;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
`

const developerCSS = css``

export const AiIndexesSectionCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
